export const loadState = () => {
  try {
    const serializedState = localStorage.getItem('hf_state');
    if (serializedState === null) {
      return {};
    }
    return JSON.parse(serializedState);
  } catch (err) {
    return undefined;
  }
};

export const saveState = (state) => {
  try {
    const serializedState = JSON.stringify(state);
    localStorage.setItem('hf_state', serializedState);
  } catch {
    // ignore write errors
  }
};
